import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { config } from '../config';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { ProductContext } from '../context/ProductsContext';
import { FaChevronDown, FaChevronUp, FaShoppingCart } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { HeaderContext } from '../context/HeaderContext';
import { useCart } from 'react-use-cart';
import CartPanel from '../components/CartPanel';
import { initFacebookPixels, trackEventOnMultiplePixels } from '../pixel';

const Shop = () => {
  const imageUrl = config.imageUrl;
  const { pixel, apiUrl, loading: productLoading, products } = useContext(ProductContext);
  const { loading: headerLoading } = useContext(HeaderContext);
  const [isCartOpen, setIsCartOpen] = useState(false);

  const { items, totalItems, addItem, updateItemQuantity, removeItem } = useCart();
  const [selectedOptions, setSelectedOptions] = useState({});
  const [openDropdowns, setOpenDropdowns] = useState({});


  const toggleDropdown = (productId) => {
    setOpenDropdowns(prev => ({
      ...prev,
      [productId]: !prev[productId]
    }));
  };

  const handleColorSelect = (productId, colorId) => {
    setSelectedOptions(prev => ({
      ...prev,
      [productId]: {
        ...prev[productId],
        colorId,
        sizeId: null // Reset size when color changes
      }
    }));
  };

  const handleSizeSelect = (productId, sizeId) => {
    setSelectedOptions(prev => ({
      ...prev,
      [productId]: {
        ...prev[productId],
        sizeId
      }
    }));
  };

  const handleAddToCart = (product) => {
    // If product has colors but none selected
    if (product.colors?.length > 0 && !selectedOptions[product.id]?.colorId) {
      alert('Please select a color');
      return;
    }

    // If product is clothing and has sizes but none selected
    if (product.clothing && product.colors?.find(c => c.id === selectedOptions[product.id]?.colorId)?.sizes?.length > 0 && !selectedOptions[product.id]?.sizeId) {
      alert('Please select a size');
      return;
    }

    // If product has single sizes but none selected
    if (product.single_product_sizes?.length > 0 && !selectedOptions[product.id]?.sizeId) {
      alert('Please select a size');
      return;
    }

    // Create cart item
    let cartItem = { ...product, product_id: product.id, price: product.discount_price || product.price };

    // Add variant details if available
    if (product.colors?.length > 0) {
      const selectedColor = product.colors.find(c => c.id === selectedOptions[product.id]?.colorId);
      const selectedSize = product.clothing ? selectedColor?.sizes?.find(s => s.id === selectedOptions[product.id]?.sizeId) : null;

      cartItem = {
        ...cartItem,
        id: `${product.id}${selectedColor ? `-${selectedColor.id}` : ''}${selectedSize ? `-${selectedSize.id}` : ''}`,
        color: selectedColor?.color || null,
        colorId: selectedColor?.id || null,
        size: selectedSize?.size || null,
        sizeId: selectedSize?.id || null,
        image: selectedColor?.image || product.images[0]?.image
      };
    }

       // Add single product size if available
      if (product.single_product_sizes?.length > 0) {
        const selectedSize = product.single_product_sizes.find(s => s.id === selectedOptions[product.id]?.sizeId);
        
        cartItem = {
          ...cartItem,
          id: `${product.id}${selectedSize ? `-${selectedSize.id}` : ''}`,
          size: selectedSize?.size || null,
          sizeId: selectedSize?.id || null
        };
      }

    addItem(cartItem);
  };


  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };


  // পিক্সেল ইনিশিয়ালাইজেশন এবং InitiateCheckout ট্র্যাকিং
    useEffect(() => {
        if (pixel.length > 0) {
            initFacebookPixels(pixel);
            
            trackEventOnMultiplePixels(pixel, 'ViewShop', {
              content_name: 'All Products',
              content_type: 'product_group',
              num_items: products.length
            });
        }
    }, [pixel]);

  // useEffect(() => {
  //   if (pixel) {
  //     initFacebookPixel(pixel);
  //     window.fbq('track', 'ViewShop', {  // অথবা 'ViewProductListing'
  //       content_name: 'All Products',
  //       content_type: 'product_group',
  //       num_items: products.length // প্রোডাক্ট কাউন্ট যোগ করুন
  //     });
  //   }
  // }, [pixel, products.length]);


  if (headerLoading || productLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-white">
         <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-green-500"></div>
      </div>
    );
  }

  return (
    <>
      <Header />

      {/* Shop Banner */}
      <div className="bg-gradient-to-r from-[#116d3c] to-[#0a2635] py-10 text-center text-white">
        <h1 className="text-4xl font-bold">Shop</h1>
        <p className="mt-2 text-lg">
          <Link to="/" className="hover:underline">Home</Link> / Shop
        </p>
      </div>

      <div className="bg-gray-50">
        <div className="container mx-auto py-6 px-2">

          {/* All Products */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2 md:gap-4">
            {[...products].reverse().map((product) => {
              const percentage = product.discount_price
                ? Math.round(((product.price - product.discount_price) / product.price) * 100)
                : 0;

                    const productOptions = selectedOptions[product.id] || {};
                    const selectedColor = product.colors?.find(c => c.id === productOptions.colorId);
                    const isDropdownOpen = openDropdowns[product.id];
                    const hasColors = product.colors?.length > 0;
                    const hasSizes = product.clothing && selectedColor?.sizes?.length > 0;
                    const hasSingleSizes = product.single_product_sizes?.length > 0;
                    const isSingleSizeProduct = hasSingleSizes && !hasColors && !product.clothing;

                  // Determine aspect ratio class based on product.clothing
                  const imageContainerClass = product.clothing 
                  ? "aspect-[3/4] overflow-hidden relative" 
                  : "aspect-[4/3] overflow-hidden relative"; 

              return (
                <div key={product.id} className="bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden flex flex-col h-full relative">
                  {/* Discount Badge */}
                  {product.discount_price && (
                    <span className="absolute top-2 left-2 bg-red-500 text-white px-2 py-1 text-xs rounded z-10">
                      {percentage}% Off
                    </span>
                  )}

                 {/* Product Image */}
                  <div className="relative aspect-square overflow-hidden">
                    <a href={`/${product.slug}`} className="block h-full w-full">
                    

                      {hasColors ? (
                        <div className="h-full w-full">
                          {product.colors.length === 1 ? (
                            <img
                              src={`${config.imageUrl}/${product.colors[0].image}`}
                              alt={product.name}
                              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                            />
                          ) : (
                            <Slider {...sliderSettings}>
                              {product.colors.map(color => (
                                <div key={color.id} className="h-full w-full">
                                  <img
                                    src={`${config.imageUrl}/${color.image}`}
                                    alt={`${color.color} ${product.name}`}
                                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                                  />
                                </div>
                              ))}
                            </Slider>
                          )}
                        </div>
                      ) : (
                        <img
                          src={`${config.imageUrl}/${product.images[0]?.image}`}
                          alt={product.name}
                          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                        />
                      )}
                    </a>
                  </div>

                  {/* Product Info */}
                  <div className='p-4 flex-grow flex flex-col'>
                    <h3 className="font-semibold text-gray-800 mb-1 line-clamp-2 text-center">
                      {product.name}
                    </h3>

                    {/* Price */}
                    <div className="flex justify-center items-center gap-2 mt-2">
                      {product.discount_price ? (
                        <>
                          <span className="text-sm text-gray-400 line-through">৳{product.price}</span>
                          <span className="text-lg font-bold text-green-600">৳{product.discount_price}</span>
                        </>
                      ) : (
                        <span className="text-lg font-bold text-green-600">৳{product.price}</span>
                      )}
                    </div>

                   {/* For products with only single sizes - show size selector directly */}
                      {isSingleSizeProduct && (
                        <div className="mt-3">
                          <label className="block text-xs text-gray-500 mb-1">Size:</label>
                          <div className="grid grid-cols-4 gap-2">
                            {product.single_product_sizes.map(size => (
                              <button
                                key={size.id}
                                onClick={() => handleSizeSelect(product.id, size.id)}
                                className={`py-1 text-xs rounded ${
                                  productOptions.sizeId === size.id 
                                    ? 'bg-blue-500 text-white' 
                                    : 'bg-gray-200 text-gray-800 hover:bg-gray-300'
                                } transition-colors`}
                              >
                                {size.size}
                              </button>
                            ))}
                          </div>
                        </div>
                      )}
  
                      {/* For products with colors/sizes - show dropdown */}
                      {(hasColors || hasSizes) > 0 && (
                        <div className="mt-3">
                          <button
                            onClick={() => toggleDropdown(product.id)}
                            className="w-full flex justify-between items-center px-3 py-2 bg-gray-100 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-200 transition-colors"
                          >
                            <span>Select Options</span>
                            {isDropdownOpen ? (
                              <FaChevronUp className="text-gray-500 text-xs" />
                            ) : (
                              <FaChevronDown className="text-gray-500 text-xs" />
                            )}
                          </button>
  
                          {isDropdownOpen && (
                            <div className="mt-2 space-y-3 animate-fadeIn">
                              {/* Color Selection */}
                              {hasColors && (
                                <div>
                                  <label className="block text-xs text-gray-500 mb-1">Color:</label>
                                  <div className="flex flex-wrap gap-2">
                                    {product.colors.map(color => (
                                      <button
                                        key={color.id}
                                        onClick={() => handleColorSelect(product.id, color.id)}
                                        className={`w-8 h-8 rounded-full border-2 ${
                                          productOptions.colorId === color.id 
                                            ? 'border-blue-500' 
                                            : 'border-gray-300'
                                        } transition-colors`}
                                        style={{ backgroundColor: color.color.toLowerCase() }}
                                        title={color.color}
                                      />
                                    ))}
                                  </div>
                                </div>
                              )}
  
                              {/* Size Selection */}
                              {hasSizes && (
                                <div>
                                  <label className="block text-xs text-gray-500 mb-1">Size:</label>
                                  <div className="grid grid-cols-4 gap-2">
                                    {selectedColor.sizes.map(size => (
                                      <button
                                        key={size.id}
                                        onClick={() => handleSizeSelect(product.id, size.id)}
                                        className={`py-1 text-xs rounded ${
                                          productOptions.sizeId === size.id 
                                            ? 'bg-blue-500 text-white' 
                                            : 'bg-gray-200 text-gray-800 hover:bg-gray-300'
                                        } transition-colors`}
                                      >
                                        {size.size}
                                      </button>
                                    ))}
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      )}
                    {/* Add to Cart Button */}
                    <button
                      onClick={() => handleAddToCart(product)}
                      className="mt-3 w-full bg-gradient-to-r from-blue-500 to-blue-600 text-white py-2 rounded-md font-medium text-sm flex items-center justify-center gap-2 hover:from-blue-600 hover:to-blue-700 transition-colors shadow-md hover:shadow-lg"
                    >
                      <FaShoppingCart className="text-sm" />
                      Add to Cart
                    </button>
                    {/* Order Button */}
                    <div className="flex justify-center items-center mt-2 space-x-2">
                      <a
                        href={`/${product.slug}`}
                        className="w-full text-white font-bold text-sm md:text-md lg:text-lg px-2 py-2 rounded-lg 
                                  bg-gradient-to-r from-green-500 to-green-700 shadow-lg transform transition-all 
                                  hover:scale-105 hover:shadow-xl flex items-center justify-center space-x-2"
                      >
                        <FaShoppingCart />
                        <span>অর্ডার করুন</span>
                      </a>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

         {/* Cart Button */}
        <button
          onClick={() => setIsCartOpen(true)}
          className="fixed right-6 bottom-6 bg-blue-600 text-white p-4 rounded-full shadow-lg hover:bg-blue-700 transition-colors z-10 flex items-center justify-center"
        >
          <FaShoppingCart className="text-xl" />
          {totalItems > 0 && (
            <span className="absolute -top-1 -right-1 bg-red-500 text-xs font-bold rounded-full h-6 w-6 flex items-center justify-center">
              {totalItems}
            </span>
          )}
        </button>

        {/* Cart Panel */}
        <CartPanel
          isOpen={isCartOpen}
          toggleCart={() => setIsCartOpen(false)}
          cartItems={items}
          removeFromCart={removeItem}
          updateQuantity={updateItemQuantity}
        />
        </div>

      <Footer />
    </>
  );
};

export default Shop;